import { SAVE_SNAPSHOT } from 'constants/actionTypes';

const initialState = null;

export default (state = initialState, action) => {
  switch (action.type) {
    case SAVE_SNAPSHOT:
      return action.snapshot || initialState;
    default:
      return state;
  }
};
